<!--  BEGIN CONTENT PART  -->
<div id="content" class="main-content">
    <div class="container">

        <div class="page-header">
            <div class="page-title">
                <h1>Notre référentiel</h1>
            </div>
            <div *ngIf="success" class="alert alert-success alert-dismissible fade show row offset-lg-8 col-lg-4" role="alert" style="background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important;">
                <strong>{{message}}!</strong> 
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div *ngIf="fail" class="alert alert-danger alert-dismissible fade show row offset-lg-7 col-lg-5" role="alert" style="background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;">
                <strong>{{message}}!</strong>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div *ngIf="loader" class="alert alert-info alert-dismissible fade show row offset-lg-8 col-lg-4 clignote" role="alert">
                <strong>{{message}}</strong> En cours.
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>

        <div class="row">
            <div class="layout-spacing col-lg-6" [ngClass]="{'col-lg-6': !mobile && !medium}" [ngClass]="{'col-lg-12 p-0': mobile || medium}">
                <div class="statbox widget box box-shadow">
                    <div class="widget-content widget-content-area modern-todo todo-l" [ngClass]="{'p-2': mobile || medium}">
                        <div id="sectors" class="header">
                            <h2 class="mb-3" style="margin:5px" *ngIf="!mobile && !medium">Secteurs d'activités</h2>
                            <h3 class="mb-5" style="margin:5px;color: white;" *ngIf="mobile || medium">Secteurs d'activités</h3>
                            <form [formGroup]="sectorForm">
                                <div class="input-group mb-4">
                                    <input type="text" class="form-control" placeholder="Saisir le nouveau secteur" aria-label="" formControlName="sector">
                                    <div class="input-group-append">
                                        <button class="btn btn-default addBtn" *ngIf="!update" type="submit" (click)="addSector()" [disabled]="sectorForm.invalid">Ajouter</button>
                                        <button class="btn btn-default addBtn" *ngIf="update" type="button" (click)="submitToUpdateSector()" [disabled]="sectorForm.invalid">Modifier</button>
                                    </div>
                                </div>
                            </form>
                            <form [formGroup]="sectorSearchForm">
                            <div class="input-group mb-4">
                                <input type="text" class="form-control" placeholder="Rechercher un secteur" aria-label="" name="sectorToSearch" formControlName="search">
                            </div>
                        </form>
                        </div>
                        <div *ngIf="sectorsLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                            margin-bottom: 15%;">
                        </div>
                        <div class="row mt-5" *ngIf="!sectorsLoader && sectorsFiltered.length==0">
                            <p class="d-block m-auto" >Aucun Secteur n'est ajoutée</p>
                        </div>
                        <ul id="todo-items-container" *ngIf="!sectorsLoader && sectorsFiltered.length>0">
                            <li class="todo-item" *ngFor="let item of sectorsFiltered">
                                <span class="text">{{item.label}}</span>
                                <span class="fa fa-pencil" (click)="updateSector(item)"></span>
                                <span class="close fa fa-times" role="button" data-toggle="modal" data-target="#deleteSectorModal" (click)="getSector(item)" title="supprimer le secteur" aria-label="Delete"></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> 

            <div class="layout-spacing col-lg-6" [ngClass]="{'col-lg-6': !mobile && !medium}" [ngClass]="{'col-lg-12 p-0': mobile || medium}">
                <div class="statbox widget box box-shadow">
                    <div class="widget-content widget-content-area modern-todo todo-l" [ngClass]="{'p-2': mobile || medium}">
                        <div id="cities" class="header">
                            <h2 class="mb-3" style="margin:5px" *ngIf="!mobile && !medium">Villes</h2>
                            <h3 class="mb-5" style="margin:5px;color: white;" *ngIf="mobile || medium">Villes</h3>
                            <form [formGroup]="cityForm">
                            <div class="input-group mb-4">
                                <input type="text" class="form-control" placeholder="Saisir la nouvelle ville" aria-label="" formControlName="city">
                                <div class="input-group-append">
                                    <button class="btn btn-default addBtn" *ngIf="!updateC" type="button" (click)="addCity()" [disabled]="cityForm.invalid">Ajouter</button>
                                    <button class="btn btn-default addBtn" *ngIf="updateC" type="button" (click)="submitToUpdateCity()" [disabled]="cityForm.invalid">Modifier</button>
                                </div>
                            </div>
                            </form>
                            <form [formGroup]="citySearchForm">
                            <div class="input-group mb-4">
                                <input type="text" class="form-control" placeholder="Rechercher une ville" aria-label="" name="cityToSearch" formControlName="search">
                            </div>
                            </form>
                        </div>
                        <div *ngIf="citiesLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                            margin-bottom: 15%;">
                        </div>
                        <div class="row mt-5" *ngIf="!citiesLoader && citiesFiltered.length==0">
                            <p class="d-block m-auto" >Aucune Ville n'est ajoutée</p>
                        </div>
                        <ul id="todo-items-container" *ngIf="!citiesLoader && citiesFiltered.length>0">
                            <li class="todo-item" *ngFor="let item of citiesFiltered">
                                <span class="text">{{item.city}}</span>
                                <span class="fa fa-pencil" (click)="updateCity(item)"></span>
                                <span class="close fa fa-times" role="button" data-toggle="modal" data-target="#deleteCityModal" (click)="getCity(item)" title="supprimer la ville" aria-label="Delete"></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> 

            <div class="layout-spacing col-lg-6" [ngClass]="{'col-lg-6': !mobile && !medium}" [ngClass]="{'col-lg-12 p-0': mobile || medium}">
                <div class="statbox widget box box-shadow">
                    <div class="widget-content widget-content-area modern-todo todo-l" [ngClass]="{'p-2': mobile || medium}">
                        <div id="topics" class="header">
                            <h2 class="mb-3" style="margin:5px" *ngIf="!mobile && !medium">Topics</h2>
                            <h3 class="mb-5" style="margin:5px;color: white;" *ngIf="mobile || medium">Topics</h3>
                            <form [formGroup]="topicForm">
                                <div class="input-group mb-4">
                                    <input type="text" class="form-control" placeholder="Saisir le nouveau topic" aria-label="" formControlName="topic">
                                    <div class="input-group-append">
                                        <button class="btn btn-default addBtn" *ngIf="!updateT" type="button" (click)="addTopic()" [disabled]="topicForm.invalid">Ajouter</button>
                                        <button class="btn btn-default addBtn" *ngIf="updateT" type="button" (click)="submitToUpdateTopic()" [disabled]="topicForm.invalid">Modifier</button>
                                    </div>
                                </div>
                                <div *ngIf="topicForm.get('topic')?.touched && 
                                                (topicForm.get('topic')?.hasError('onlySpaces') || 
                                                topicForm.get('topic')?.hasError('specialCharacters') || 
                                                topicForm.get('topic')?.hasError('noValidCharacters'))"
                                        style="color: black; text-align: justify; margin-top: -25px;" class="mb-1">
                                    <small *ngIf="topicForm.get('topic')?.hasError('onlySpaces')">Le topic ne peut pas contenir uniquement des espaces</small>
                                    <small *ngIf="topicForm.get('topic')?.hasError('specialCharacters')">Caractères non autorisés</small>
                                    <small *ngIf="topicForm.get('topic')?.hasError('noValidCharacters')">Le topic doit contenir au moins une lettre ou un chiffre</small>
                                </div>
                            </form>
                            <form [formGroup]="topicSearchForm">
                                <div class="input-group mb-4">
                                    <input type="text" class="form-control" placeholder="Rechercher un topic" aria-label="" name="topicToSearch" formControlName="search">
                                </div>
                            </form>
                            <!-- <div *ngIf="topicsLoader" class="cp-spinner cp-bubble cp-bubble-action-ref" style="margin: auto;display: block;margin-top: 40%;
                                margin-bottom: 40%;"></div> -->
                            <div *ngIf="successTopic" class="alert alert-success alert-dismissible fade show row offset-lg-8 col-lg-4" 
                                role="alert" style="position: absolute;padding: 7px;margin: auto;bottom: 56%;max-width: 85%;
                                background-image: linear-gradient(135deg, #6effc05c 0, #6d94805c 100%) !important;">
                                <strong>{{message}}!</strong> 
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div *ngIf="failTopic" class="alert alert-danger alert-dismissible fade show row offset-lg-7 col-lg-5" 
                                role="alert" style="position: absolute;padding: 7px;margin: auto;bottom: 56%;max-width: 85%;
                                background-image: linear-gradient(135deg, #ff6e995c 0, #946d6d5c 100%) !important;">
                                <strong>{{message}}!</strong>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="topicsLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                            margin-bottom: 15%;">
                        </div>
                        <div class="row mt-5" *ngIf="!topicsLoader && topicsFiltered.length==0">
                            <p class="d-block m-auto" >Aucune Topic n'est ajoutée</p>
                        </div>
                        <ul id="todo-items-container" *ngIf="!topicsLoader && topicsFiltered.length>0">
                            <li class="todo-item" *ngFor="let item of topicsFiltered">
                                <span class="text">{{item.topic}}</span>
                                <span class="fa fa-pencil" (click)="updateTopic(item)"></span>
                                <span class="close fa fa-times" role="button" data-toggle="modal" data-target="#deleteTopicModal" (click)="getTopic(item)" title="supprimer la ville" aria-label="Delete"></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div class="layout-spacing col-lg-6" [ngClass]="{'col-lg-6': !mobile && !medium}" [ngClass]="{'col-lg-12 p-0': mobile || medium}">
                <div class="statbox widget box box-shadow">
                    <div class="widget-content widget-content-area modern-todo todo-l" [ngClass]="{'p-2': mobile || medium}">
                        <div id="classes" class="header">
                            <h2 class="mb-3" style="margin:5px" *ngIf="!mobile && !medium">Classes</h2>
                            <h3 class="mb-5" style="margin:5px;color: white;" *ngIf="mobile || medium">Classes</h3>
                            <form [formGroup]="classSearchForm">
                                <div class="input-group mb-4">
                                    <input type="text" class="form-control" placeholder="Rechercher une classe" aria-label="" name="cityToSearch" formControlName="search">
                                </div>
                            </form>
                        </div>
                        <div *ngIf="classesLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                            margin-bottom: 15%;">
                        </div>
                        <div class="row mt-5" *ngIf="!classesLoader && classesFiltered.length==0">
                            <p class="d-block m-auto" >Aucune Classe n'est ajoutée</p>
                        </div>
                        <ul id="todo-items-container" *ngIf="!classesLoader && classesFiltered.length>0">
                            <li class="todo-item row font-weight-bold" *ngIf="classesFiltered.length>0">
                                <span class="text col ">Classe</span>
                                <span class="text col">Visite/période</span>
                                <span class="text col">Visite/an</span>
                            </li>
                            <li class="todo-item row" *ngFor="let item of classesFiltered">
                                <span class="text col">{{item.refClass}}</span>
                                <span class="text col">{{item.period}}</span>
                                <span class="text col">{{item.year}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> 

            <div class="layout-spacing col-lg-6" [ngClass]="{'col-lg-6': !mobile && !medium}" [ngClass]="{'col-lg-12 p-0': mobile || medium}">
                <div class="statbox widget box box-shadow" >
                    <div class="widget-content widget-content-area modern-todo todo-l" [ngClass]="{'p-2': mobile || medium}">
                        <div id="sectors" class="header">
                            <h2 class="mb-3" style="margin:5px" *ngIf="!mobile && !medium">Familles/Catégories</h2>
                            <h3 class="mb-5" style="margin:5px;color: white;" *ngIf="mobile || medium">Familles/Catégories</h3>
                            <form [formGroup]="productCategoryForm">
                                <div class="input-group mb-4">
                                    <input type="text" class="form-control" placeholder="Saisir la nouvelle famille/catégorie" aria-label="" formControlName="productCategory">
                                    <div class="input-group-append">
                                        <button class="btn btn-default addBtn" *ngIf="!updateFl" type="submit" (click)="addProductCategory()" [disabled]="productCategoryForm.invalid">Ajouter</button>
                                        <button class="btn btn-default addBtn" *ngIf="updateFl" type="button" (click)="checkUseOfProductCategory()" [disabled]="productCategoryForm.invalid">Modifier</button>
                                        <button class="btn btn-default addBtn" *ngIf="updateFl" type="button" (click)="cancelUpdProductCategory()" >Annuler</button>
                                    </div>
                                </div>
                            </form>
                            <form [formGroup]="productCategorySearchForm">
                                <div class="input-group mb-4">
                                    <input type="text" class="form-control" placeholder="Rechercher une famille/catégorie" aria-label="" name="productCategoryToSearch" formControlName="search">
                                </div>
                            </form>
                            <div *ngIf="categoriesLoader" class="cp-spinner cp-bubble cp-bubble-action-ref" style="margin: auto;display: block;margin-top: 40%;
                                margin-bottom: 40%;"></div>
                            <div *ngIf="successProductCategory" class="alert alert-success alert-dismissible fade show row offset-lg-8 col-lg-4" 
                                role="alert" style="position: relative;padding: 7px;margin: auto;bottom: 57%;max-width: 85%;
                                background-image: linear-gradient(135deg, #6effc05c 0, #6d94805c 100%) !important;">
                                <strong>{{message}}!</strong> 
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div *ngIf="failProductCategory" class="alert alert-danger alert-dismissible fade show row offset-lg-7 col-lg-5" 
                                role="alert" style="position: relative;padding: 7px;margin: auto;bottom: 57%;max-width: 85%;
                                background-image: linear-gradient(135deg, #ff6e995c 0, #946d6d5c 100%) !important;">
                                <strong>{{message}}!</strong>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="categoriesLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                            margin-bottom: 15%;">
                        </div>
                        <div class="row mt-5" *ngIf="!categoriesLoader && categoriesFiltered.length==0">
                            <p class="d-block m-auto" >Aucune Famille/catégorie n'est ajoutée</p>
                        </div>
                        <ul id="todo-items-container" *ngIf="!categoriesLoader">
                            <li class="todo-item" *ngFor="let item of categoriesFiltered">
                                <span class="text">{{item.category}}</span>
                                <span class="fa fa-pencil" (click)="updateProductCategory(item)"></span>
                                <span class="close fa fa-times" role="button" data-toggle="modal" data-target="#deleteProductCategoryModal" (click)="getProductCategory(item)" title="supprimer la famille/catégorie" aria-label="Delete"></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</div>
<!--  END CONTENT PART  -->

  
<!-- delete sector Modal -->
<div class="modal" tabindex="-1" role="dialog" id="deleteSectorModal" style="z-index: 9999;" *ngIf="sectorToDelete">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
        
            <div class="modal-body">
                <div class="my-3 text-center">
                    <h4> <span> Voulez-vous vraiment supprimer ce secteur: {{sectorToDelete.label}}? </span></h4>
                </div>
            </div>

            <div  class="modal-footer justify-content-center">
                <button type="button" class="btn btn-secondary rounded-pill" data-dismiss="modal">Annuler</button>
                <button type="button" class="btn btn-danger mx-2 rounded-pill"(click)="deleteSector(sectorToDelete.id)" data-dismiss="modal">Supprimer</button>  
            </div>
        
        </div>
    </div>
</div>

<!-- delete sector Modal -->
<div class="modal" tabindex="-1" role="dialog" id="deleteCityModal" style="z-index: 9999;" *ngIf="cityToDelete">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
        
            <div class="modal-body">
                <div class="my-3 text-center">
                    <h4> <span> Voulez-vous vraiment supprimer cette ville: {{cityToDelete.city}}? </span></h4>
                </div>
            </div>

            <div  class="modal-footer justify-content-center">
                <button type="button" class="btn btn-secondary rounded-pill" data-dismiss="modal">Annuler</button>
                <button type="button" class="btn btn-danger mx-2 rounded-pill"(click)="deleteCity(cityToDelete.uuid)" data-dismiss="modal">Supprimer</button>  
            </div>
        
        </div>
    </div>
</div>

<!-- delete Topic Modal -->
<div class="modal" tabindex="-1" role="dialog" id="deleteTopicModal" style="z-index: 9999;" *ngIf="topicToDelete">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
        
            <div class="modal-body">
                <div class="my-3 text-center">
                    <h4> <span> Voulez-vous vraiment supprimer ce topic: {{topicToDelete.topic}}? </span></h4>
                </div>
            </div>

            <div  class="modal-footer justify-content-center">
                <button type="button" class="btn btn-secondary rounded-pill" data-dismiss="modal">Annuler</button>
                <button type="button" class="btn btn-danger mx-2 rounded-pill"(click)="deleteTopic(topicToDelete.uuid)" data-dismiss="modal">Supprimer</button>  
            </div>
        
        </div>
    </div>
</div>

<!-- delete ProductCategory Modal -->
<div class="modal" tabindex="-1" role="dialog" id="deleteProductCategoryModal" style="z-index: 9999;" *ngIf="productCategoryToDelete">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
        
            <div class="modal-body">
                <div class="my-3 text-center">
                    <h4> <span> Voulez-vous vraiment supprimer cette famille/catégorie : {{productCategoryToDelete.category}}? </span></h4>
                </div>
            </div>

            <div  class="modal-footer justify-content-center">
                <button type="button" class="btn btn-secondary rounded-pill" data-dismiss="modal">Annuler</button>
                <button type="button" class="btn btn-danger mx-2 rounded-pill"(click)="deleteProductCategory(productCategoryToDelete.uuid)" data-dismiss="modal">Supprimer</button>  
            </div>
        
        </div>
    </div>
</div>

<!--  ECHEC delete / Confirm Update ProductCategory Modal -->
<div id="echecDeleteFamily" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
    <div class="modal-dialog modal-lg"> 
        <div class="modal-content">
            <div class="modal-header border-0">
                <div class="col-lg-12 text-center data-widgets br-4">
                    <div class="widget  t-sales-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-warning btn-gradient-warning" style="background-color: #ffa42c;color: white;"></i>
                            </div>
                        </div>
                    </div>
                </div>   
            </div>
            <div class="form-group text-center mb-4 col-lg-12 col-lg-12 col-md-12 col-sm-12 ml-1" style="width: 100%;">
                <!-- <b class="col-lg-12 col-lg-12 col-md-12 col-sm-12">{{infoCrudMessage}} </b> -->
                <div class="my-3 text-center">
                    <h4> <span>{{infoCrudMessage}} </span></h4>
                </div>
                    <br>
                <span *ngIf="echecDetails.length==0"> Vérification Impact ...</span>
                <div *ngIf="loadingChecking" class="cp-spinner cp-bubble cp-bubble-action-ref" style="margin: auto;display: block;margin-top: 40%;
                    margin-bottom: 40%;"></div>
                <span style="float: inline-start;" *ngIf="echecDetails.length>0" class="text-danger"><b> {{echecDetails?.length}} Vente(s) impactée(s) </b> </span><br><br>
                <div class="listview-outlook" data-role="listview" style="max-height: 245px;overflow: auto;">
                    <a class="list marked active " href="javascript:void(0)" *ngFor="let info of echecDetails">
                        <div class="list-content pl-2 mb-2">
                            <span class="list-title"><b>Client : </b><a [attr.href]="'/customer/fromRef;cs='+info?.customerId+';vs='" class="link">{{info.customer}}</a> </span><br>
                            <span class="list-subtitle"><b>Date de vente : </b> 
                                <span style="color: black;">{{info.saleDate | date: 'dd/MM/yyyy - HH:mm '}}</span>
                            </span><br>
                            <span class="list-subtitle" *ngIf="info.visitCode!=null">
                                <b>Visite : </b> <a href="visite/detail/fromRef;cr={{info.visitId}}" class="link">{{info.visitCode}}</a>
                                    -- du : <span style="color: black;">{{info.visitDate | date: 'dd/MM/yyyy - HH:mm '}}</span>
                            </span><br *ngIf="info.visitCode!=null">
                        </div>
                    </a>
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-sm-12">
                <div class="">  
                    <div class="text-center md-button" style="display: grid;">
                        <button type="button" class="btn btn-gradient-dark btn-rounded mt-3 mb-0 mr-2"
                            (click)="submitToUpdateProductCategory()" *ngIf="updateHasImpact" data-dismiss="modal">
                            Modifier comme même</button>
                        <button type="button" class="btn btn-default btn-rounded mt-2 mb-3" data-dismiss="modal">Retour</button>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</div>